<template>
  <div class="c-resources-container" id="js-resources">
    <div class="c-resources-basket" v-if="this.resources.length > 0 && this.step !== this.steps">
      <div class="c-resources-basket__container">
      <button
        class="c-button c-button--brand c-resources__button"
        v-on:click="nextStep"
      >
        {{ renderViewOrderButtonText() }}
      </button>
      </div>
    </div>
    <div class="grid-container">
      <div class="c-resources__header">
        <h1 class="c-resources__heading" v-if="options.heading">
          {{ options.heading }}
        </h1>
      </div>
    </div>

    <div class="c-resources__stage-container">
      <div
        class="c-resources__stage"
        :class="this.step == 2 ? 'is-active' : null"
        v-if="options.showForm"
      >
        <div class="grid-container">
          <div class="c-confirmation-message">
            <div
              v-if="formSuccess"
              class="
                c-confirmation-message__content
                c-confirmation-message__content--success
              "
            >
              <div class="c-rte">
                <h3>{{ options.successTitle }}</h3>
                <p>{{ options.successMessage }}</p>
              </div>
            </div>

            <div
              v-if="formError"
              class="
                c-confirmation-message__content
                c-confirmation-message__content--error
              "
            >
              <div class="c-rte">
                <h3>{{ options.errorTitle }}</h3>
                <p>{{ options.errorMessage }}</p>
              </div>
            </div>
          </div>
        </div>

        <form-box
          v-if="options.showForm"
          v-bind:backButtonText="options.backButtonText"
          v-bind:submitButtonText="options.submitButtonText"
          v-bind:headingBlockOne="options.headingBlockOne"
          v-bind:headingBlockTwo="options.headingBlockTwo"
          v-bind:titleLabel="options.title"
          v-bind:otherTitleLabel="options.otherTitle"
          v-bind:emailLabel="options.email"
          v-bind:extraDetailsLabel="options.extraDetails"
          v-bind:firstNameLabel="options.firstName"
          v-bind:lastNameLabel="options.lastName"
          v-bind:numberLabel="options.number"
          v-bind:firstLineOfAddressLabel="options.firstLineOfAddress"
          v-bind:requestedItems="resources"
          v-bind:secondLineOfAddressLabel="options.secondLineOfAddress"
          v-bind:summaryHeading="options.summaryHeading"
          v-bind:thirdLineOfAddressLabel="options.thirdLineOfAddress"
          v-bind:postcodeLabel="options.postcode"
          v-bind:title="formBoxData.title"
          v-bind:email="formBoxData.email"
          v-bind:extraDetails="formBoxData.extraDetails"
          v-bind:firstLineOfAddress="formBoxData.firstLineOfAddress"
          v-bind:firstName="formBoxData.firstName"
          v-bind:lastName="formBoxData.lastName"
          v-bind:number="formBoxData.number"
          v-bind:otherTitle="formBoxData.otherTitle"
          v-bind:postcode="formBoxData.postcode"
          v-bind:secondLineOfAddress="formBoxData.secondLineOfAddress"
          v-bind:thirdLineOfAddress="formBoxData.thirdLineOfAddress"
          v-bind:emailValidationMessage="options.emailValidationMessage"
          v-bind:extraDetailsValidationMessage="
            options.extraDetailsValidationMessage
          "
          v-bind:firstLineOfAddressValidationMessage="
            options.firstLineOfAddressValidationMessage
          "
          v-bind:firstNameValidationMessage="options.firstNameValidationMessage"
          v-bind:lastNameValidationMessage="options.lastNameValidationMessage"
          v-bind:numberValidationMessage="options.numberValidationMessage"
          v-bind:otherTitleValidationMessage="
            options.otherTitleValidationMessage
          "
          v-bind:postcodeValidationMessage="options.postcodeValidationMessage"
          v-bind:secondLineOfAddressValidationMessage="
            options.secondLineOfAddressValidationMessage
          "
          v-bind:thirdLineOfAddressValidationMessage="
            options.thirdLineOfAddressValidationMessage
          "
          v-bind:titleValidationMessage="options.titleValidationMessage"
          v-on:collateDetails="collateDetails"
          v-on:prevStep="prevStep"
          v-on:removeItem="removeItem"
          v-on:updateQuantity="updateQuantity"
          v-on:valueChange="formBoxValueChange"
        ></form-box>
      </div>
      <div
        class="c-resources__stage"
        v-bind:class="[
          this.step == 1 ? 'is-active' : null,
          this.resources.length > 0 ? 'has-fixed-button' : null,
        ]"
      >
        <div class="grid-container">
          <div class="c-resources__subheading">
            <h2 v-if="searchResultsText" class="c-resources__subheading__title">
              {{ searchResultsText }}
            </h2>
            <a
              href="#"
              v-if="options.expandFilters"
              v-bind:class="[
                showFilters
                  ? 'c-expand-filters c-expand-filters--open'
                  : 'c-expand-filters',
              ]"
              v-on:click="expandFilters"
              >{{ options.expandFilters.text }}</a
            >
          </div>
        </div>
        <div class="c-resources" v-show="showFilters">
          <div class="c-resources__inner grid-container">
            <div class="c-resources__filters">
              <div class="c-resources__column">
                <drop-down
                  v-if="options.sortByOptions"
                  v-bind:filters="options.sortByOptions"
                  event-name="updateSortBy"
                />
                <drop-down
                  v-if="options.typeOptions"
                  v-bind:filters="options.typeOptions"
                  event-name="updateType"
                />
              </div>
              <div class="c-resources__column">
                <checkbox v-bind:filters="options.filters" />
              </div>
            </div>
            <div class="c-resources__btn-wrapper">
              <a
                href="#"
                class="c-button c-button--brand"
                v-on:click="filterEventHandler"
                >{{ options.buttonText }}</a
              >
            </div>
          </div>
        </div>

        <div class="grid-container">
          <div class="c-resources__results c-resources__results-container">
            <resources-results-card
              v-for="result in results"
              v-bind:key="result.id"
              v-bind:result="result"
              v-bind:requestedButtonsText="requestedButtonsText"
              v-bind:requestedButtonsActiveText="requestedButtonsActiveText"
              v-bind:requestedItems="resources"
              v-bind:showForm="options.showForm"
              v-on:addItem="addItem"
              v-on:removeItem="removeItem"
            />
          </div>
          <div
            class="c-resources__no-results"
            v-if="options.noResults && results.length === 0"
          >
            <p>{{ noResultsText }}</p>
          </div>
          <div
            class="c-resources__btn-container"
            v-if="options.loadMoreText && pageNumber < totalPages"
          >
            <button
              class="c-button c-button--brand"
              v-on:click="loadMoreResultsHandler"
            >
              {{ options.loadMoreText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "url-search-params-polyfill";
import axios from "axios";
import endpoints from "Globals/mando.endpoints";
import Checkbox from "./form/elements/Checkbox";
import DropDown from "./form/elements/DropDown";
import FormBox from "./form/Form";
import FormInput from "./form/elements/FormInput";
import FormSelect from "./form/elements/FormSelect";
import ResourcesResultsCard from "./card/Card.vue";
export default {
  name: "resources",
  components: {
    Checkbox,
    DropDown,
    FormBox,
    FormInput,
    FormSelect,
    ResourcesResultsCard,
  },
  data() {
    return {
      steps: 2,
      step: 1,
      resources: [],
      formBoxData: {
        email: "",
        extraDetails: "",
        firstLineOfAddress: "",
        firstName: "",
        lastName: "",
        number: "",
        otherTitle: "",
        postcode: "",
        secondLineOfAddress: "",
        thirdLineOfAddress: "",
        title: "",
      },
      searchTerm: "",
      location: "",
      tags: "",
      sortBy: "",
      type: "",
      showFilters: "",
      results: [],
      pageNumber: null,
      totalPages: null,
      totalResults: null,
      searchResultsText: null,
      noResultsText: null,
      formError: false,
      formSuccess: false,
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    searchConfig: {
      type: String,
      required: true,
    },
    componentId: {
      type: String,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
  },
  created() {
    this.$eventBus.$on("updateFilters", this.updateFilterValues);
    this.$eventBus.$on("updateSortBy", this.updateSortByValues);
    this.$eventBus.$on("updateType", this.updateTypeValues);
    this.$eventBus.$on("updateSearchTerm", this.UpdateSearchTermValue);
    this.$eventBus.$on("updateLocation", this.UpdateLocationValue);
    this.$eventBus.$on("onSearchClick", this.searchBoxEventHandler);
  },
  mounted() {
    const initialQueryString = this.buildQueryString();

    axios
      .get(`${endpoints("getResourcesResults")}${initialQueryString}`)
      .then((response) => {
        this.results = response.data.results;
        this.requestedButtonsText = response.data.requestedButtonsText;
        this.requestedButtonsActiveText =
          response.data.requestedButtonsActiveText;
        this.pageNumber = response.data.pageNumber;
        this.totalPages = response.data.totalPages;
        this.totalResults = response.data.totalResults;
        this.setSearchResultsText(response.data.totalResults);
      })
      .catch((error) => console.warn(error));
  },
  methods: {
    collateDetails() {
      const payload = {
        email: this.formBoxData.email,
        extraDetails: this.formBoxData.extraDetails,
        firstLineOfAddress: this.formBoxData.firstLineOfAddress,
        firstName: this.formBoxData.firstName,
        lastName: this.formBoxData.lastName,
        number: this.formBoxData.number,
        otherTitle: this.formBoxData.otherTitle,
        postcode: this.formBoxData.postcode,
        resources: this.resources,
        secondLineOfAddress: this.formBoxData.secondLineOfAddress,
        thirdLineOfAddress: this.formBoxData.thirdLineOfAddress,
        title: this.formBoxData.title,
        searchConfigId: this.searchConfig,
      };

      axios
        .post(`${endpoints("postResourcesResults")}`, payload)
        .then((response) => {
          this.formError = false;
          this.formSuccess = true;
        })
        .catch((error) => {
          this.formSuccess = false;
          this.formError = true;
        });

      this.scrollToElement("js-resources");
    },
    formBoxValueChange(key, value) {
      this.formBoxData[key] = value;
    },
    getQuery(key, searchTerm) {
      const query =
        searchTerm &&
        searchTerm.split("&").filter((item) => item.indexOf(key) > -1);

      return query.length && query[0].split("=")[1];
    },
    buildQueryString() {
      const searchTerm = window.location.search;
      let params = {
        searchConfig: this.searchConfig,
        componentId: this.componentId,
        siteId: this.siteId,
      };
      if (this.searchTerm || this.getQuery("searchTerm", searchTerm)) {
        params = Object.assign(params, {
          searchTerm:
            this.searchTerm || this.getQuery("searchTerm", searchTerm),
        });
      }
      if (this.location || this.getQuery("region", searchTerm)) {
        params = Object.assign(params, {
          region:
            this.location === "any"
              ? ""
              : this.location || this.getQuery("region", searchTerm),
        });
      }
      if (this.type) {
        params = Object.assign(params, { type: this.type });
      }
      if (this.sortBy) {
        params = Object.assign(params, { sortBy: this.sortBy });
      }
      if (this.tags) {
        params = Object.assign(params, { tags: this.tags });
      }
      const queryString = Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&");

      return Object.keys(params).length ? encodeURI(`?${queryString}`) : "";
    },

    searchResults(pageNumber) {
      const self = this;
      const queryString = this.buildQueryString();
      const pageResults = `&page=${pageNumber}`;

      axios
        .get(`${endpoints("getResourcesResults")}${queryString}${pageResults}`)
        .then((response) => {
          if (!self.pagingActive) {
            self.results = response.data.results;
          } else {
            self.results = self.loadMoreResults(response.data.results);
            self.pagingActive = false;
          }
          self.pageNumber = pageNumber ? pageNumber : 1;
          self.totalPages = response.data.totalPages;
          self.totalResults = response.data.totalResults;
          self.setSearchResultsText(response.data.totalResults);
          return self.$eventBus.$emit("updatedSearchResults", queryString);
        })
        .catch((error) => console.warn(error));
    },
    loadMoreResults(newResults) {
      const result = [...new Set([...this.results, ...newResults])];
      return result;
    },
    searchBoxEventHandler() {
      this.searchResults();
    },
    setSearchResultsText(resultCount) {
      const convertedSearchResultsText = this.options.searchResultsText.replace(
        "{total}",
        resultCount
      );
      this.searchResultsText = convertedSearchResultsText;
    },
    setNoResultsText(searchTerm) {
      const noResultsText = this.options.noResults.replace(
        "{searchTerm}",
        searchTerm
      );
      this.noResultsText = noResultsText;
    },
    filterEventHandler(e) {
      this.pagingActive = false;
      e.preventDefault();
      this.searchResults();
    },
    UpdateSearchTermValue(item) {
      this.searchTerm = item;
      this.setNoResultsText(item);
    },
    UpdateLocationValue(item) {
      this.location = item;
    },
    updateFilterValues(item) {
      this.tags = item.join(",");
    },
    updateSortByValues(item) {
      this.sortBy = item;
    },
    updateTypeValues(item) {
      this.type = item;
    },
    updateQuantity(id, quantityValue) {
      this.resources.forEach((item) => {
        if (item.id === id) {
          item.quantity = quantityValue;
        }
      });
    },
    expandFilters(e) {
      e.preventDefault();
      let expandFilterState = (this.options.expandFilters.isOpen =
        !this.options.expandFilters.isOpen); // toggles boolean state
      this.showFilters = expandFilterState;
    },
    loadResultsPage(pageNumber) {
      this.pagingActive = true;
      this.searchResults(pageNumber);
    },
    loadMoreResultsHandler(e) {
      e.preventDefault();
      this.pageNumber = this.pageNumber + 1;
      this.pagingActive = true;
      this.searchResults(this.pageNumber);
    },
    addItem(item) {
      this.resources.push({
        id: item.id,
        name: item.title,
        label: item.type,
        quantity: 1,
      });
    },
    removeItem(id) {
      this.resources = this.resources.filter((item) => item.id !== id);
      if (this.resources.length === 0) {
        this.prevStep();
      }
    },
    renderViewOrderButtonText() {
      if (
        this.options.viewOrderButtonText === "" ||
        this.options.viewOrderButtonText === null ||
        !this.options.viewOrderButtonText
      ) {
        return `View order (${this.resources.length})`;
      } else {
        return `${this.options.viewOrderButtonText} (${this.resources.length})`;
      }
    },
    prevStep() {
      if (this.step > 1) {
        this.scrollToElement("js-resources");
        this.step--;
      }
      return;
    },
    nextStep() {
      if (this.step < this.steps && this.options.showForm) {
        this.scrollToElement("js-resources");
        this.step++;
      }
      return;
    },
    scrollToElement(id) {
      const el = document.getElementById(id);
      el.scrollIntoView(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/geneco/resources/Resources.vue